import React from "react";
import { Link } from "react-router-dom";
import { Ticket, ArrowRight, Shield, CreditCard, Download } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const CTASection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="section bg-gradient-to-br from-romanian-blue via-primary-600 to-romanian-blue relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-romanian-yellow/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-romanian-red/10 rounded-full blur-3xl" />

      {/* Romanian pattern top */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-romanian-blue via-romanian-yellow to-romanian-red" />

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-romanian-yellow rounded-2xl mb-8 animate-float">
            <Ticket className="w-10 h-10 text-romanian-blue" />
          </div>

          {/* Title */}
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            {t.cta.title}
          </h2>

          {/* Description */}
          <p className="text-white/90 text-lg md:text-xl mb-8 max-w-2xl mx-auto leading-relaxed">
            {t.cta.description}
          </p>
          {/* CTA Button */}
          <div className="mb-12">
            <Link
              to="/acces"
              className="inline-flex items-center space-x-3 bg-romanian-yellow text-romanian-blue px-10 py-5 rounded-xl font-bold text-lg hover:bg-white transition-colors shadow-2xl hover:shadow-white/20 group"
            >
              <span>{t.cta.button}</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center space-x-2 text-white/80">
              <Shield className="w-5 h-5 text-romanian-yellow" />
              <span className="text-sm">{t.cta.securePayment}</span>
            </div>
            <div className="flex items-center space-x-2 text-white/80">
              <CreditCard className="w-5 h-5 text-romanian-yellow" />
              <span className="text-sm">Stripe Checkout</span>
            </div>
            <div className="flex items-center space-x-2 text-white/80">
              <Download className="w-5 h-5 text-romanian-yellow" />
              <span className="text-sm">{t.cta.instantPdf}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Romanian pattern bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-romanian-red via-romanian-yellow to-romanian-blue" />
    </section>
  );
};

export default CTASection;
